export const PATH = {
  ROOT: "/",
  FORGOT_PASSWORD: "/forgot-password",
  SIGNUP: "/signup",
  RESET_PASSWORD: "/reset-password",
  DISABLE_MFA: "/disable-mfa",
  DASHBOARD: "/dashboard",

  //User Routes
  AGENT_MANAGEMENT: "/organization/user-management",
  AGENT_BULK_IMPORT: "/organization/user-management/bulk-import",
  AGENT_PERMISSIONS: "/organization/user-management/permissions",
  AGENT_PRICING: "/organization/user-management/pricing",

  //Organization Routes
  ORGANIZATION: "/organization/organization-management",
  PREFERENCE: "/organization/preference",
  CREATE_ORGANIZATION: "/organization/organization-management/create",
  UPDATE_ORGANIZATION: "/organization/organization-management/:id/update",
  MANAGE_PRICING:
    "/organization/organization-management/:orgId/manage-pricing/:financialProfileId",
  WEBSITE_MANAGEMENT: "/organization/website-management",
  WHATSAPP_MANAGEMENT: "/organization/whatsapp-management",
  PASSENGER_MANAGEMENT: "/organization/passenger-management",
  PASSENGER_PROFILE: "/organization/passenger-management/profile/",
  ORGANIZATION_DOCUMENTS: "/organization/documents",
  SAAS_ELITE_ORGANIZATION: "/organizations/saas-elite-organization",
  EMPLOYEE_GRADE: "/organization/employee-grade",
  COST_CENTER: "/organization/cost-center",
  CORPORATE_POLICY: "/organization/corporate-policy",
  CORPORATE_POLICY_CREATE: "/organization/corporate-policy/create",
  CORPORATE_POLICY_DETAILS: "/organization/corporate-policy/:id",
  MY_POLICIES: "/my-policies",
  MY_POLICIES_DETAILS: "/my-policies/:id",
  DEPARTMENT: "/organization/department",
  APPROVAL_SYSTEM: "/organization/approval-workflow",
  APPROVAL_SYSTEM_CREATE: "/organization/approval-workflow/create",
  APPROVAL_SYSTEM_DETAIL: "/organization/approval-workflow/:workflowId",
  APPROVAL_SYSTEM_EDIT: "/organization/approval-workflow/:workflowId/edit",
  APPROVAL_REQUESTS: "/organization/approval-requests",
  APPROVAL_REQUEST_DETAIL: "/organization/approval-requests/:requestId",
  MY_APPROVALS: "/approvals/my-approvals",
  MY_APPROVAL_DETAIL: "/approvals/my-approvals/:requestId",
  ASSIGNED_APPROVALS: "/approvals/assigned-approvals",
  ASSIGNED_APPROVAL_DETAIL: "/approvals/assigned-approvals/:requestId",

  // Sales Routes
  SALES: "/sales",
  MY_TEAM: "/my-team",

  //SOA Routes
  SOA: "/soa",

  //My Booking routes
  MY_BOOKINGS: "/my-bookings",

  //Flights Routes
  FLIGHTS: "/flights",

  FLIGHTS_SEARCH_RESULT: "/flights/search/result",
  FLIGHTS_SEARCH_RESULT_V1: "/flights/search/result/v1",

  FLIGHTS_BOOKING_FORM: "/flights/booking/:id",
  FLIGHTS_BOOKING_DETAILS_OLD: "/flights/booking-details/old/:id",
  FLIGHTS_BOOKING_DETAILS: "/flights/booking-details/:id",
  FLIGHTS_BOOKING_DETAILS_NEW: "/flights/booking-details/new/:id",
  FLIGHT_ISSUANCE: "/flights/issuance",
  FLIGHT_REFUNDS: "/flights/refunds",

  //Payment routes
  PAYMENTS: "/payments",
  CREATE_PAYMENT: "/payments/create",
  PAYMENT_DETAIL: "/payments/detail/:id",
  // Aeroglobe_Tutorials
  TUTORIALS: "https://aeroglobe.carrd.co/",

  // FDG - Group Flights
  FIX_DEPARTURE_GROUP: "/fdg",
  FDG_FLIGHTS: "/fdg/flights",
  FDG_FLIGHT_DETAIL: "/fdg/flights/:id",
  FDG_FLIGHT_BOOKING_CONFIRMATION: "/fdg/booking/:id",
  FDG_BOOKING_DETAILS: "/fdg/booking-details/:id",

  // FDG - Umrah
  FDG_UMRAH: "/fdg/umrah",
  FDG_UMRAH_DETAIL: "/fdg/umrah/:id",
  FDG_UMRAH_BOOKING_CONFIRMATION: "/fdg/booking/:id",

  FIT_HOTELS: "/umrah-hotels",

  // Hotel Routes
  HOTELS: "/hotels",
  HOTELS_SEARCH_RESULT: "/hotels/search/result",
  HOTEL_PROPERTY_VIEW: "/hotels/property/:id",
  HOTEL_PROPERTY_BOOKING_FORM: "/hotels/booking/:id",
  HOTEL_BOOKING_DETAILS: "/hotels/booking-details/:id",

  // profile routes
  USER_PROFILE: "/profile",
  CHANGE_PASSWORD: "/profile/changePassword",

  //Payment routes
  CREDIT_LIMIT_MANAGEMENT: "/credit-limit-management",
  CREATE_CREDIT_LIMIT_REQUEST: "/credit-limit-management/create",
  CREDIT_LIMIT_REQUEST_DETAIL: "/credit-limit-management/:id",

  // issuance logs
  ISSUANCE_LOGS: "/issuance-logs/:pnr",
  ISSUANCE_LOGS_WITHOUT_PNR: "/issuance-logs",

  SABRE_SEGMENT: "/sabre-segment/",

  NEWS: "/news/",

  FARE_MANAGEMENT: "/fare-management",

  PRICING: "/pricing",

  Error_403: "/403",

  Error_404: "/:pathMatch(.*)*",

  MANAGE_QUOTATIONS: "/manage-quotations",

  CURRENCY_CONVERSION: "/currency-conversion",

  DEALS_AND_PROMOS: "/deals-and-promos",

  VISA_VERIFICATION: "/ok-to-board",
  ADD_VISA_VERIFICATION_REQ: "/ok-to-board/add-request",
  DOWNLOAD_VISA_VERIFICATION: "/verify-visa/:name-:id",

  // snapshots
  SNAPSHOTS: "/report",
  DIGITAL_PAYMENTS: "/reports/digital-payments",
  ORGANIZATION_SNAPSHOT: "/reports/organization-snapshot",
  SECTOR_SNAPSHOT: "/reports/sector-snapshot",
  SALES_SNAPSHOT: "/reports/sales-snapshot",
  DAILY_ISSUANCE: "/reports/daily-issuance",

  //my issuances
  MY_ISSUANCE: "/my-issuances",
  FLIGHTS_ISSUANCE_DETAILS:
    "/flights/issuance-detail/:id/organization-id=:organizationId",
  CHURNING: "/churning",
  GROUPS: "/groups",
  GROUP_BOOKING_DETAILS: "/groups/booking-details/:id",
};
